import React from 'react';
import Retail from '../../../../Assets/Odoo/OdooServicesIcons/retailnew.jpg';
import Eleraning from '../../../../Assets/Odoo/OdooServicesIcons/elearn 1.jpg';
const OdooIndustries = () => {
  const services = [
    {
      id: 1,
      title: "Retail, Ecommerce",
      image: Retail
    },
    {
      id: 2,
      title: "Education & e-learning",
      image: Eleraning
    },
    {
      id: 3,
      title: "Healthcare & Fitness",
      image: "https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/images/images/health.jpg?updatedAt=1750404000202"
    },
    {
      id: 4,
      title: "Logistics & Distribution",
      image: "https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/images/images/logistics.jpg?updatedAt=1750404000231"
    },
    {
      id: 5,
      title: "Social Networking",
      image: "https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/images/images/social.jpg?updatedAt=1750404000251"
    },
    {
      id: 6,
      title: "Real Estate",
      image: "https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/images/images/realestate.jpg?updatedAt=1750404000167"
    },
    {
      id: 7,
      title: "Travel & Hospitality",
      image: "https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/images/images/travel.jpg?updatedAt=1750404000190"
    },
    {
      id: 8,
      title: "Food & Restaurant",
      image: "https://ik.imagekit.io/kqumni8l2/OdooServicesIcons/images/images/food.jpg?updatedAt=1750404000172"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f8f9fa] to-[#e8f4f8] py-1 px-3">
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-10">
         
          <h1 className="text-4xl md:text-5xl font-bold text-[#2c2c54] mb-4 leading-tight">
            Odoo ERP Implementation Services
            <span className="block text-3xl md:text-4xl bg-gradient-to-r from-[#714b67] to-[#8f4a7e] bg-clip-text text-transparent mt-2">
              for Various Industries
            </span>
          </h1>
          <p className="text-lg text-[#495057] max-w-2xl mx-auto text-center">
            Transform your business operations with our comprehensive Odoo ERP solutions tailored for diverse industry needs
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden"
              style={{
                animationDelay: `${index * 100}ms`,
                animation: 'fadeInUp 0.6s ease-out forwards'
              }}
            >
              {/* Card Background Gradient */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#f0e9f4] to-[#e6d8ea] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Image Container */}
              <div className="relative overflow-hidden rounded-t-2xl bg-gradient-to-br from-[#f8f9fa] to-[#e8f4f8]"
                // style={{ border: '1px solid #e31515', height: '230px', width: '260px'}}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#714b67]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              {/* Content Container */}
              <div className="relative p-1 text-center">
                <h3 className="text-md  text-[#2c2c54] group-hover:text-[#714b67] transition-colors duration-300 text-center">
                  {service.title}
                </h3>
                
                {/* Hover Effect Line */}
                <div className="w-0 group-hover:w-full h-0.5 bg-gradient-to-r from-[#714b67] to-[#8f4a7e] transition-all duration-500 mx-auto mt-3"></div>
              </div>

              {/* Floating Elements */}
              <div className="absolute top-4 right-4 w-8 h-8 bg-[#714b67]/20 rounded-full opacity-0 group-hover:opacity-100 transform translate-x-4 group-hover:translate-x-0 transition-all duration-300"></div>
              <div className="absolute top-6 right-6 w-4 h-4 bg-[#8f4a7e]/10 rounded-full opacity-0 group-hover:opacity-100 transform translate-x-6 group-hover:translate-x-0 transition-all duration-500"></div>
            </div>
          ))}
        </div>

        
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default OdooIndustries ;